import { Button } from "primereact/button";

export const useGetCustomers = () => {
  const columns = [
    { field: "firstName", header: "First Name" },
    { field: "lastName", header: "Last Name" },
    { field: "businessName", header: "Business" },
    { field: "phoneNumber", header: "Phone" },
    { field: "city", header: "City" },
    { field: "state", header: "State" },
    {
      field: "",
      header: "",
      body: () => (
        <div className="flex gap-2 p-button-text p-button-sm">
          <Button className="p-button-text p-button-sm" />
        </div>
      ),
    },
  ];

  return { columns };
};
